import { useSelector } from 'react-redux';

import { INTAKE_NON_SAVE_LOADING_KEYS } from './constants';

import type { RootState } from '../../../../store';

// True while any intake field save (create / update / delete) is in flight.
// Field saves fire on blur and run asynchronously, so a write can still be
// reaching the server after the user opens the conclude dialog. Conclude must
// wait for these to finish, otherwise it can overtake the last save and
// persist a snapshot that drops that change. Every save toggles a `*Loading`
// flag; the handful that aren't saves are excluded via the blocklist.
export default function useIsIntakeSaving() {
  return useSelector((state: RootState) =>
    Object.entries(state.intakeQuestionnaire).some(
      ([key, value]) =>
        value === true &&
        key.endsWith('Loading') &&
        !INTAKE_NON_SAVE_LOADING_KEYS.includes(key),
    ),
  );
}
